
import { observable, action, makeObservable } from 'mobx';
import UserStore from './user-store';
import PractitionerStore from './practitioner-store';
import PatientStore from './patient-store';
import ClinicStore from './clinic-store';
import PrescriptionStore from './prescription-store';
import HerbStore from './herb-store';
import LibraryStore from './library-store';
import PackageStore from './package-store';
import OptionStore from './option-store';
import BookingStore from './booking-store';
import EventStore from './event-store';
import CanvasStore from "./canvas-store";
import HicapsTerminalStore from "./hicaps-terminal-store";
import PermissionRoleStore from "./permission-role-store";
import XeroStore from "./xero-store";

interface WebNotification {
  message: string;
  options?: {
    variant: "success" | "error" | "info" | "warning";
  };
}

export default class RootStore {
  testVal = "TEST_VALUE";

  destination = "Select";

  notification: WebNotification = {
    message: "",
    options: {
      variant: "info",
    },
  };

  userStore;
  practitionerStore;
  patientStore;
  clinicStore;
  prescriptionStore;
  herbStore;
  libraryStore;
  packageStore;
  optionStore;
  bookingStore;
  eventStore;
  canvasStore;
  hicapsTerminalStore;
  permissionRoleStore;
  xeroStore;

  constructor() {
    makeObservable(this, {
      testVal: observable,
      destination: observable,
      notification: observable,
      notify: action,
    });
    this.userStore = new UserStore(this);
    this.practitionerStore = new PractitionerStore(this);
    this.patientStore = new PatientStore(this);
    this.clinicStore = new ClinicStore(this);
    this.prescriptionStore = new PrescriptionStore(this);
    this.herbStore = new HerbStore(this);
    this.libraryStore = new LibraryStore(this);
    this.packageStore = new PackageStore(this);
    this.optionStore = new OptionStore(this);
    this.bookingStore = new BookingStore(this);
    this.eventStore = new EventStore(this);
    this.canvasStore = new CanvasStore(this);
    this.hicapsTerminalStore = new HicapsTerminalStore(this);
    this.permissionRoleStore = new PermissionRoleStore(this);
    this.xeroStore = new XeroStore(this);
  }

  notify(msg: string, level?: "success" | "error" | "info" | "warning") {
    if (level) {
      this.notification = {
        message: msg,
        options: {
          variant: level,
        },
      };
    } else {
      this.notification = {
        message: msg,
      };
    }
  }
}
